import { createContext, ReactNode, useState } from 'react'
import {
  SalesTeam,
  SalesTeamCommissionRule,
  SalesTeamExternalSale,
  SalesTeamPagination,
  SalesTeamRulesStep,
  TeamRulesTypeEnum,
  TSalesTeamContext,
} from '../types/SalesTeam'

type Props = {
  children?: ReactNode
}

const initialValue = {} as TSalesTeamContext
const SalesTeamContext = createContext<TSalesTeamContext>(initialValue)

const SalesTeamProvider = ({ children }: Props) => {
  const [rowsPerPage, setRowsPerPage] = useState(3)
  const [pagination, setPagination] = useState<SalesTeamPagination | null>(null)
  const [stepRule, setStepRule] = useState(SalesTeamRulesStep.List)
  const [commissionRule, setCommissionRule] =
    useState<SalesTeamCommissionRule | null>(null)
  const [current, setCurrent] = useState<SalesTeam | null>(null)
  const [referenceDate, setReferenceDate] = useState(new Date())
  const [externalSale, setExternalSale] =
    useState<SalesTeamExternalSale | null>(null)

  const isCurrentTeamLeader = () => {
    return commissionRule?.ruleType === TeamRulesTypeEnum.Leader
  }

  return (
    <SalesTeamContext.Provider
      value={{
        rowsPerPage,
        setRowsPerPage,
        pagination,
        setPagination,
        stepRule,
        setStepRule,
        commissionRule,
        setCommissionRule,
        isCurrentTeamLeader,
        current,
        setCurrent,
        referenceDate,
        setReferenceDate,
        externalSale,
        setExternalSale,
      }}
    >
      {children}
    </SalesTeamContext.Provider>
  )
}

export { SalesTeamContext, SalesTeamProvider }
